// 第三方/登录相关接口
const auth = {
    qq_login_path: '/user/login/qq/path',
    qq_login: '/user/login/qq',
    send_sms: '/user/send_sms',
    oss_sts_token: '/oss/sts_token',
}
export default auth; 